import * as R from "ramda";
import { Button, Col, Form, Row } from "antd";
import React, { forwardRef, useImperativeHandle } from "react";

import "./search-form.scss";

// // noinspection JSUnusedGlobalSymbols
// export class SearchComponentForm extends Component {
//   render() {
//     const {
//       form,
//       children,
//       onSearch = R.F,
//       onReset = R.F,
//       showSearch = R.F,
//       showReset = R.F,
//       columns = 3,
//     } = this.props;
//     const showButton = showSearch || showReset;
//
//     return (
//       <Form
//         className="ant-advanced-search-form"
//         onFinish={() => onSearch(form.getFieldsValue())}
//       >
//         <Row gutter={24}>
//           {React.Children.toArray(children).map((child, index) => (
//             <Col
//               span={24 / (columns || 3)}
//               key={`${child.props.name || ""}-${index}`}
//             >
//               {child}
//             </Col>
//           ))}
//         </Row>
//         {showButton && (
//           <Row>
//             <Col span={24} style={{ textAlign: "right" }}>
//               {showSearch && (
//                 <Button type="primary" htmlType="submit">
//                   确定
//                 </Button>
//               )}
//               {showReset && (
//                 <Button
//                   style={{ marginLeft: 8 }}
//                   onClick={() => {
//                     form.resetFields();
//                     onReset(form.getFieldsValue());
//                     onSearch(form.getFieldsValue());
//                   }}
//                 >
//                   重置
//                 </Button>
//               )}
//             </Col>
//           </Row>
//         )}
//       </Form>
//     );
//   }
// }

export const HookSearchForm = forwardRef((props, ref) => {
  const { form } = props;
  const children = React.Children.toArray(R.pathOr({}, ["children"], props));
  const onSearch = R.pathOr(R.F, ["onSearch"], props);
  const onReset = R.pathOr(R.F, ["onReset"], props);

  const showSearch = R.pathOr(false, ["showSearch"], props);
  const showReset = R.pathOr(false, ["showReset"], props);

  // 是否显示 "搜索" 或 "重置" 按钮
  const showButton = showSearch || showReset;

  useImperativeHandle(ref, () => ({
    form,
  }));

  return (
    <Form
      className="ant-advanced-search-form"
      onFinish={() => onSearch(form.getFieldsValue())}
    >
      <Row gutter={24}>
        {children.map((child, index) => {
          return (
            <Col
              span={24 / R.pathOr(3, ["columns"], props)}
              key={`${R.pathOr("", ["props", "name"], child)}-${index}`}
            >
              <Form.Item label={R.pathOr("", ["props", "label"], child)}>
                {form.getFieldDecorator(
                  R.pathOr("", ["props", "name"], child),
                  R.pathOr({}, ["props", "decorator"], child)
                )(child)}
              </Form.Item>
            </Col>
          );
        })}
      </Row>
      {showButton && (
        <Row>
          <Col span={24} style={{ textAlign: "right" }}>
            {showSearch && (
              <Button type="primary" htmlType="submit">
                确定
              </Button>
            )}
            {showReset && (
              <Button
                style={{ marginLeft: 8 }}
                onClick={() => {
                  form.resetFields();
                  onReset(form.getFieldsValue());
                  onSearch(form.getFieldsValue());
                }}
              >
                重置
              </Button>
            )}
          </Col>
        </Row>
      )}
    </Form>
  );
});

/**
 * <AdvanceSearchForm ref={formRef} columns={3|4} showSearch showReset onChange onSearch onReset>
 *   <Form.Item>...</Form.Item>
 * </AdvanceSearchForm>
 */
export const AdvanceSearchForm = Form.create({
  name: "advanced_search",
  onValuesChange: (props, changedValues, allValues) => {
    if (props.onChange) {
      props.onChange(allValues, changedValues);
    }
  },
})(HookSearchForm);



// WEBPACK FOOTER //
// ./src/containers/Video/widgets/search-form.js